export { GruvLogoMark } from "@project-x/ui-kit";
export type { GruvLogoMarkProps } from "@project-x/ui-kit";
